import { t } from "@lingui/macro";

import {
  HStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";

export const YourSpotRow = () => {
  return (
    <HStack alignItems="center" gap={3} paddingVertical={2}>
      <OutlineSquare />
      <Text variant="mainBaseSemiBold">{t`Your Spot`}</Text>
    </HStack>
  );
};

const OutlineSquare = () => {
  return (
    <Box
      width={24}
      height={24}
      backgroundColor="surface-dividers"
      borderColor="outline-primary"
      borderWidth={1.5}
      borderStyle={"dashed"}
      borderRadius="2"
    />
  );
};
